<template>
  <v-form v-model="valid">
    <v-text-field
      :label="$t('updateProfile.fullName')"
      prepend-icon="person"
      name="fullname"
      v-model="userProfile.full_name"
      :disabled="!isEditing"
      data-vv-name="fullname"
      :error-messages="errors.collect('fullname')"
    ></v-text-field>
    <v-text-field
      :label="$t('common.email')"
      prepend-icon="email"
      name="email"
      v-validate="'required|email'"
      data-vv-name="email"
      :disabled="!isEditing"
      :error-messages="errors.collect('email')"
      v-model="userProfile.email"
      required
    ></v-text-field>
    <v-text-field
      label="Phone country code"
      prepend-icon="location_city"
      placeholder="###"
      data-vv-name="country_code"
      :disabled="!isEditing"
      v-model="userProfile.phone_country_code"
    ></v-text-field>
    <v-text-field
      :label="$t('updateProfile.phone')"
      prepend-icon="phone"
      placeholder="### - ####"
      data-vv-name="phone"
      :disabled="!isEditing"
      :error-messages="errors.collect('phone')"
      v-model="userProfile.phone_number"
      mask="phone"
    ></v-text-field>

    <v-autocomplete
      v-model="userProfile.timezone"
      :items="listTimeZones"
      :label="$t('updateProfile.timezone')"
      prepend-icon="location_city"
      item-text="name"
      item-value="identifier"
      :disabled="!isEditing"
    >
    </v-autocomplete>

    <v-subheader class="pa-0 mt-3">ADDRESS</v-subheader>
    <v-text-field
      :label="$t('updateProfile.address')"
      prepend-icon="location_on"
      data-vv-name="address"
      :disabled="!isEditing"
      :error-messages="errors.collect('address')"
      v-model="userProfile.address"
    ></v-text-field>
    <div class="form-btn">
      <v-btn outlined @click="edit" color="red" v-if="!isEditing">{{ $t("button.edit") }}</v-btn>
      <v-btn outlined @click="submit" color="primary" v-if="isEditing"
        >{{ $t("button.submit") }}</v-btn
      >
    </div>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    formModel: {},
    valid: true,
    isEditing: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    userProfile: {}
  }),
  computed: {
    ...mapGetters(["currentUser", "listTimeZones"])
  },
  mounted() {
    this.userProfile = JSON.parse(JSON.stringify(this.currentUser));
    this.$validator.localize("en", this.dictionary);
    this.fetchTimezone();
  },
  methods: {
    edit() {
      this.isEditing = true;
    },
    submit() {
      this.$validator.validateAll();
      this.$store
        .dispatch("updateProfile", this.userProfile)
        .then(() => {
          this.form = {};
          this.$validator.reset();
          this.snackbar = {
            show: true,
            color: "green",
            text: "Your profile has been successfully updated."
          };
          this.isEditing = false;
        })
        .catch(error => {
          let message = error.response.data.errors.full_messages[0];
          this.snackbar = {
            show: true,
            color: "red",
            text: message
          };
        });
    },
    clear() {
      this.formModel = {};
      this.$validator.reset();
    },
    fetchTimezone() {
      this.$store.dispatch("fetchListTimezones", this.$route.params.id);
    }
  }
};
</script>
